// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2emDm","label":"styles_label__1sbJY"};